import React, { Fragment } from 'react'

const Values = (props) => {
    const { values } = props;
    
    return (
        <Fragment>
            {/* error duhet mi pas kto per required */}
            {/* onChange={formik.handleChange}
            value={formik.values.EmriRaportuesi}
            onBlur={formik.handleBlur}
            error={formik.touched.EmriRaportuesi && formik.errors.EmriRaportuesi} */}

            {/* Shembull Fushat Required */}
            {/* <TextInput
                label="Emri"
                name="EmriRaportuesi"
                placeholder="Emri"
                required
                 onChange={formik.handleChange}
                value={formik.values.EmriRaportuesi}
                 onBlur={formik.handleBlur}
                 error={formik.touched.EmriRaportuesi && formik.errors.EmriRaportuesi}
                inputWrapperOrder={['label', 'error', 'input']}
            /> */}

            {/* Shemnull Raio button */}
            {/* <Radio.Group
                label="Gjinia"
                name='GenderRaportuesi'
                value={formik.values.GenderRaportuesi}
                onChange={(value) => formik.setFieldValue('GenderRaportuesi', value)}
                withAsterisk
            >
                <Group mt="xs">
                    <Radio color="#051A53" value="M" label="M" />
                    <Radio color="#051A53" value="F" label="F" />
                </Group>
            </Radio.Group> */}

            {/* Shembull Select */}
            {/* <Select
                searchable
                clearable
                required
                data={institutionsData}
                label="Institucioni"
                placeholder="Institucioni"
                name='InstitucioniRaportuesi'
                onChange={(selected) => {
                    formik.setFieldValue('InstitucioniRaportuesi', selected);
                }}
                value={formik.values.InstitucioniRaportuesi}
            /> */}

            {/* Shembull fushat jo required */}
            {/* <TextInput
                label="Numri i telefonit"
                placeholder="Numri i telefonit"
                leftSectionPointerEvents="none"
                type="tel"
                name='NrTelRaportuesi'
                onChange={(e) => formik.setFieldValue('NrTelRaportuesi', e.target.value)}
                value={formik.values.NrTelRaportuesi}
                leftSection={<MdOutlinePhoneEnabled />}
            /> */}
        </Fragment>
    )
}

export default Values